  document.addEventListener('DOMContentLoaded', function() {
  const contactForm = document.getElementById('contactForm');
  const workerUrl = window.CONTACT_WORKER_URL;

  const callBackSelect = document.getElementById('callBack');
  const phoneInput = document.getElementById('phone');
  
  if (callBackSelect && phoneInput) {
    function togglePhoneRequirement() {
      if (callBackSelect.value === 'yes') {
        phoneInput.setAttribute('required', 'required');
      } else {
        phoneInput.removeAttribute('required');
      }
    }

  // Set initial state on page load
  togglePhoneRequirement();

  // Update requirement whenever the dropdown changes
  callBackSelect.addEventListener('change', togglePhoneRequirement);
  }

  // Display elements after picking an enquiry type
  const dropdown = document.getElementById('subject'); // Fix the ID

  const productModels = document.getElementById('productmodels');
const serialNumber = document.getElementById('serialNumber');
const dataRemoval = document.getElementById('data_removal_message');
const priceMatchLink = document.getElementById('priceMatchLink');
const orderWithdrawalFields = document.getElementById('orderWithdrawalFields');
const orderNumberInput = document.querySelector('[data-name="orderNumber"]');
const orderWithdrawalConfirmedInput = document.querySelector('[data-name="orderWithdrawalConfirmed"]');

  const productModelsLabel = document.querySelector('#productmodels label#product_model_optional small');
  const serialNumberLabel  = document.querySelector('#serialNumber label#serial_number_optional small');
  const productModelsOptional = document.getElementById('product_model_optional');
  const serialNumberOptional = document.getElementById('serial_number_optional');

  dropdown.addEventListener('change', function () {
  const selected = dropdown.value;

  const isWithdrawalRequest =
    selected === "Contact Page: Cancellations Returns Refunds Enquiry" ||
    selected === "Order Withdrawal Request";

    // Always hide all
productModels.style.display = 'none';
serialNumber.style.display = 'none';
dataRemoval.style.display = 'none';
priceMatchLink.style.display = 'none';

if (orderWithdrawalFields) orderWithdrawalFields.style.display = 'none';
if (orderNumberInput) orderNumberInput.removeAttribute('required');
if (orderWithdrawalConfirmedInput) orderWithdrawalConfirmedInput.removeAttribute('required');

    // Show relevant elements
    const showProductAndSerial = [
      "Contact Page: General Enquiry",
      "Contact Page: Technical Support",
      "Contact Page: Repairs and Warranty",
      "Contact Page: Spare Parts",
      "Contact Page: Business Enquiry",
      "Contact Page: Cancellations Returns Refunds Enquiry"
    ];

    if (showProductAndSerial.includes(selected)) {
      productModels.style.display = 'block';
      serialNumber.style.display = 'block';
    }

    if (selected === "Contact Page: Remove My Data") {
      dataRemoval.style.display = 'block';
    }

    if (selected === "Contact Page: Price Guarantee") {
      priceMatchLink.style.display = 'block';
    }

if (isWithdrawalRequest) {
  if (orderWithdrawalFields) orderWithdrawalFields.style.display = 'block';
  if (orderNumberInput) orderNumberInput.removeAttribute('required');
  if (orderWithdrawalConfirmedInput) orderWithdrawalConfirmedInput.removeAttribute('required');
}

    // 🔹 Ensure required attributes + hide/show "optional" labels
  toggleProductSerialRequirement();
    
  });

  



  // Make product model & serial number required if enquiry type is "Repairs and Warranty"

if (dropdown && productModels && serialNumber) {
  function toggleProductSerialRequirement() {
    if (dropdown.value === "Contact Page: Repairs and Warranty") {
      productModels.querySelector('select').setAttribute('required', 'required');
      serialNumber.querySelector('input').setAttribute('required', 'required');
      } else {
      productModels.querySelector('select').removeAttribute('required');
      serialNumber.querySelector('input').removeAttribute('required');
      }
  }
  
  // Set initial requirement state
  toggleProductSerialRequirement();

  // Update whenever enquiry type changes
  dropdown.addEventListener('change', toggleProductSerialRequirement);
}

  // Display elements after picking an enquiry type - ends
  
  if (contactForm) {
    // Helper function to get form values by data-name attribute
    function getFormValueByName(formData, name) {
      const field = contactForm.querySelector(`[data-name="${name}"]`);
      if (!field) return null;
      
      // Check if it's a checkbox
      if (field.type === 'checkbox') {
        return field.checked ? 'yes' : 'no';
      }
      
      // For everything else, get the value from formData using the Salesforce field ID
      return formData.get(field.name);
    }
    
    // Get field ID by data-name attribute
    function getFieldIdByName(name) {
      const field = contactForm.querySelector(`[data-name="${name}"]`);
      return field ? field.name : null;
    }
    
    // Salesforce field mapping function - updated to work with Salesforce IDs
    function mapToSalesforceFields(formData, finalMessage) {
      // Get Salesforce field IDs for key fields
      const emailFieldId = getFieldIdByName('email');
      const firstNameFieldId = getFieldIdByName('firstName');
      const lastNameFieldId = getFieldIdByName('lastName');
      const phoneFieldId = getFieldIdByName('phone');
      const countryFieldId = getFieldIdByName('country');
      const formTypeFieldId = getFieldIdByName('formType');
      const enquiryTypeFieldId = getFieldIdByName('enquiryType');
      const productmodelsFieldId = getFieldIdByName('productmodels');
const serialNumberFieldId = getFieldIdByName('serialNumber');
const orderNumberFieldId = getFieldIdByName('orderNumber');
const orderWithdrawalConfirmedFieldId = getFieldIdByName('orderWithdrawalConfirmed');

const newsletterFieldId = getFieldIdByName('newsletter');
      const privacyConsentFieldId = getFieldIdByName('privacyConsent');

      return {
        // Contact information - use the Salesforce IDs directly
        'sf_email': formData.get(emailFieldId),
        'sf_firstName': formData.get(firstNameFieldId),
        'sf_lastName': formData.get(lastNameFieldId),
        'sf_phone': formData.get(phoneFieldId),
        'sf_country': formData.get(countryFieldId),
        
        // Enquiry details
        'sf_formType': document.querySelector('[data-id="formType"]').value,
        'sf_enquiryType': formData.get(enquiryTypeFieldId),
'sf_productModel': formData.get(productmodelsFieldId),
'sf_serialNumber': formData.get(serialNumberFieldId),
'sf_message': finalMessage,
        
        // Marketing preferences
        'newsletter': formData.get(newsletterFieldId),
        'sf_privacyConsent': document.querySelector(`[data-id="privacyConsent"]`).checked ? 'yes' : 'no',
        
        // Submission metadata
        'sf_submissionDate': new Date().toISOString(),
        'sf_submissionURL': window.location.href
      };
    }
    
    contactForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      // Get form values
      // Modify phone before collecting form data
      const dialCode = document.getElementById('dialCode')?.value || '';
      const phoneInput = document.getElementById('phone');
      const fullPhone = dialCode + (phoneInput?.value.trim().replace(/^0+/, '') || '');
      if (phoneInput) phoneInput.value = fullPhone;
      
      // Now collect form data
      const formData = new FormData(contactForm);

      // Build the final message once
      const messageFieldId = getFieldIdByName('message');
      let finalMessage = formData.get(messageFieldId) || '';
      const callbackSelect = document.getElementById('callBack');
      if (callbackSelect && callbackSelect.value === 'yes') {
        finalMessage = "!!! Customer selected YES they would like a call back !!!\n" + finalMessage;
      }
      const priceMatchInput = document.getElementById('priceMatchInput');
      if (priceMatchInput && priceMatchInput.value.trim() !== '') {
        finalMessage = "Price Match Info:\n" + priceMatchInput.value.trim() + "\n\n" + finalMessage;
      }

      const selectedEnquiryType = formData.get(getFieldIdByName('enquiryType'));
const orderNumberValue = orderNumberInput ? orderNumberInput.value.trim() : '';
const withdrawalConfirmedValue = orderWithdrawalConfirmedInput && orderWithdrawalConfirmedInput.checked ? 'yes' : 'no';

// Keep finalMessage unchanged here.
// The Worker will add withdrawal/order details before sending to Salesforce.

            
      const klaviyoListId = document.querySelector('[data-id="klaviyoListId"]').value;
      
      // Check if the user wants to subscribe to the newsletter
      const wantsNewsletter = getFormValueByName(formData, 'newsletter') === 'yes';
      
      // Show loading state
      const submitButton = contactForm.querySelector('button[type="submit"]');
      const originalButtonText = submitButton.textContent;
      submitButton.disabled = true;
      // submitButton.textContent = 'Submitting...';
      
      try {
        // Generate Salesforce data mapping
        const salesforceData = mapToSalesforceFields(formData, finalMessage);
        console.log('Salesforce data:', salesforceData);

               
        // Map form fields to the structure expected by your worker
        const payload = {
          // Common fields
          formType: document.querySelector('[data-id="formType"]').value,
          firstName: getFormValueByName(formData, 'firstName'),
          lastName: getFormValueByName(formData, 'lastName'),
          email: getFormValueByName(formData, 'email'),
          newsletter: getFormValueByName(formData, 'newsletter'),
          region: getFormValueByName(formData, 'region'),
          productmodels: getFormValueByName(formData, 'productmodels'),
          serialNumber: getFormValueByName(formData, 'serialNumber'),
          withdrawalOrderNumber: getFormValueByName(formData, 'orderNumber'),
          withdrawalRequested: getFormValueByName(formData, 'orderWithdrawalConfirmed'),
          // contactPhone: getFormValueByName(formData, 'contactPhone'),
          // returnsPolicyUrl: getFormValueByName(formData, 'returnsPolicyUrl'),
          // refundsPolicyUrl: getFormValueByName(formData, 'refundsPolicyUrl'),

          // Klaviyo settings
          klaviyo: {
            listId: klaviyoListId,
            addToList: wantsNewsletter
          },
          
          // Salesforce data
          salesforce: salesforceData,
          
          // All other form fields
          phone: fullPhone,
          country: getFormValueByName(formData, 'country'),
          enquiryType: getFormValueByName(formData, 'enquiryType'),
          message: finalMessage,
          website_url: window.location.href
        };

        // ✅ Execute reCAPTCHA and inject token into payload
        grecaptcha.ready(function () {
        grecaptcha.execute('6Lfh3kIrAAAAAGD4NBTJ6C8m73MZ5TWIwh-t95CU', { action: 'submit' }).then(async function (token) {
          try {
            payload.recaptchaToken = token;
            console.log('Submitting contact form to Worker:', window.CONTACT_WORKER_URL);
console.log('Payload being sent:', payload);
            const response = await fetch(window.CONTACT_WORKER_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload)
            });
      
            const result = await response.json();
            console.log('Worker response:', result);
            console.log('Salesforce response:', result.salesforce);
            console.log('Worker logs:', result.logs);
      
            // Logging and success handling...
            if (result.error) throw new Error(result.error);
      
            if (result.db && result.db.success) {
              document.getElementById('formSuccess').style.display = 'block';
            } else if (result.klaviyo && result.klaviyo.success) {
              document.getElementById('formSuccess').style.display = 'block';
            } else {
              throw new Error('Form submission failed');
            }
      
            contactForm.reset();
          } catch (error) {
            console.error('Detailed error:', error);
            document.getElementById('formError').style.display = 'block';
          } finally {
            submitButton.disabled = false;
            submitButton.textContent = originalButtonText;
          }
        });
      }); // closes grecaptcha.ready
    } catch (error) {
      console.error('Detailed error:', error);
      document.getElementById('formError').style.display = 'block';
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;
    }
  }); // closes form submit handler

     // 7. Popup Modal Logic
  const popupContainer = document.getElementById('customPopupContainer');
  const popupTriggers = document.querySelectorAll('.popup-trigger');
  const overlay = document.getElementById('customPopupOverlay');
  const closeButton = document.querySelector('.custom-popup-close');
  
  function showPopup(contentHTML) { 
    popupContainer.innerHTML = contentHTML; // Inject custom content
    overlay.style.display = 'flex'; // Show overlay
    document.body.style.overflow = 'hidden'; // Disable scrolling
  }
  function closePopup() { 
    overlay.style.display = 'none'; // Hide overlay
    popupContainer.innerHTML = ''; // Clear popup content
    document.body.style.overflow = 'auto'; // Re-enable scrolling  
  }
  
  popupTriggers.forEach(trigger => { 
    trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const contentId = this.getAttribute('data-popup-content'); // Get the ID of the content to show
        const contentHTML = document.getElementById(contentId).innerHTML; // Fetch the HTML
        showPopup(contentHTML); // Show the popup with fetched content
    });
  });
  closeButton.addEventListener('click', closePopup);
  overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
          closePopup();
      }
  });
  document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
          closePopup();
      }
  });
    
}

   
}); // closes DOMContentLoaded